import script from "./CorpCustomerStatistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./CorpCustomerStatistics.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__